module.exports = __webpack_public_path__ + "static/media/Zamzamah in front of University Hall c. 1910.db124e24.jpg";